package component.image

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import feature.mediaFile.repository.MediaFileRepository
import feature.mediaFile.viewModel.MediaFileViewModel
import native.FilePickerView
import theme.ThemeColor

@Composable
fun CircularImageView(
    id: String,
    isEditable: Boolean = false,
    viewModel: MediaFileViewModel = MediaFileViewModel(MediaFileRepository())
) {
    val media = viewModel.mediaFiles.collectAsState()
    LaunchedEffect(key1 = Unit) {
        viewModel.loadMedia(id)
    }
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(180.dp)
            .background(ThemeColor.shared().White, shape = RoundedCornerShape(10.dp))
            .clip(RoundedCornerShape(10.dp))
            .padding(0.dp),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(180.dp)
                .clip(CircleShape)
                .padding(20.dp)
                .background(ThemeColor.shared().White, shape = RoundedCornerShape(10.dp))
                .border(2.dp, ThemeColor.shared().PrimaryColor, CircleShape),
            contentAlignment = Alignment.Center
        ) {
            if (media.value.isNotEmpty()) {
                FilePickerView(id = media.value.first()._id)
            } else {
                FilePickerView(null)
            }
        }
    }
}